<template>
  <section class="section-container">
    <div class="content-wrapper">
      <div class="content-heading">
        <div>{{ $t('profile.settings') }}</div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div role="tabpanel">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a
                        aria-controls="personaldata"
                        class="nav-link active"
                        data-toggle="tab"
                        href="#personaldata"
                        role="tab">{{ $t('profile.personal-data') }}
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                        aria-controls="account"
                        class="nav-link"
                        data-toggle="tab"
                        href="#account"
                        role="tab">{{ $t('profile.account') }}
                    </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div id="personaldata" class="tab-pane active" role="tabpanel">
                    <div class="row">
                      <div class="col-md-6">
                        <form class="form-modal form-profile" @submit.prevent="save_user">
                          <div class="form-group">
                            <label>{{ $t('profile.first-name') }}</label>
                            <input
                                v-model="user.first_name"
                                :class="{'parsley-error': errors.first_name}"
                                class="form-control"
                                type="text"
                            >
                          </div>
                          <ul v-if="errors.first_name" class="parsley-errors-list filled">
                            <li class="parsley-required">{{ errors.first_name[0] }}</li>
                          </ul>
                          <div class="form-group">
                            <label>{{ $t('profile.last-name') }}</label>
                            <input
                                v-model="user.last_name"
                                :class="{'parsley-error': errors.last_name}"
                                class="form-control"
                                type="text"
                            >
                          </div>
                          <ul v-if="errors.last_name" class="parsley-errors-list filled">
                            <li class="parsley-required">{{ errors.last_name[0] }}</li>
                          </ul>

                          <div class="form-group">
                            <label>{{ $t('profile.personal-code') }}</label>
                            <input
                                v-model="user.personal_code"
                                :class="{'parsley-error': errors.personal_code}"
                                :disabled="is_personal_code_disabled"
                                class="form-control"
                                type="text"
                            >
                          </div>
                          <ul v-if="errors.personal_code" class="parsley-errors-list filled">
                            <li class="parsley-required">{{ errors.personal_code[0] }}</li>
                          </ul>

                          <div class="form-group">
                            <label>{{ $t('profile.email') }}</label>
                            <input
                                v-model="user.email"
                                :class="{'parsley-error': errors.email}"
                                class="form-control"
                                type="text"
                            >
                          </div>
                          <ul v-if="errors.email" class="parsley-errors-list filled">
                            <li class="parsley-required">{{ errors.email[0] }}</li>
                          </ul>

                          <div class="form-group">
                            <label>{{ $t('profile.phone') }}</label>
                            <input
                                v-model="user.phone"
                                :class="{'parsley-error': errors.phone}"
                                class="form-control"
                                type="text"
                            >
                          </div>
                          <ul v-if="errors.phone" class="parsley-errors-list filled">
                            <li class="parsley-required">{{ errors.phone[0] }}</li>
                          </ul>
                          <div class="form-group">
                            <label>{{ $t('profile.position') }}</label>
                            <input
                                v-model="user.position"
                                :class="{'parsley-error': errors.position}"
                                class="form-control"
                                type="text"
                            >
                          </div>
                          <ul v-if="errors.position" class="parsley-errors-list filled">
                            <li class="parsley-required">{{ errors.position[0] }}</li>
                          </ul>
                          <button class="btn btn-info" type="submit">{{ $t('profile.save') }}</button>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div id="account" class="tab-pane" role="tabpanel">
                    <div class="row">
                      <div class="col-md-6">
                        <form class="form-modal form-profile" @submit.prevent="save_account">
                          <div class="form-group">
                            <label>{{ $t('profile.current-password') }}</label>
                            <input
                                v-model="current_password"
                                :class="{'parsley-error': errors.current_password}"
                                autocomplete="off"
                                class="form-control"
                                type="password">
                            <ul v-if="errors.current_password" class="parsley-errors-list filled">
                              <li class="parsley-required">{{ errors.current_password[0] }}</li>
                            </ul>
                          </div>
                          <div class="form-group">
                            <label>{{ $t('profile.new-password') }}</label>
                            <input
                                v-model="new_password"
                                :class="{'parsley-error': errors.new_password}"
                                autocomplete="off"
                                class="form-control"
                                type="password">
                            <ul v-if="errors.new_password" class="parsley-errors-list filled">
                              <li class="parsley-required">{{ errors.new_password[0] }}</li>
                            </ul>
                          </div>
                          <div class="form-group">
                            <label>{{ $t('profile.new-password-adain') }}</label>
                            <input
                                v-model="new_password_2"
                                :class="{'parsley-error': errors.new_password_2}"
                                autocomplete="off"
                                class="form-control"
                                type="password">
                            <ul v-if="errors.new_password_2" class="parsley-errors-list filled">
                              <li class="parsley-required">{{ errors.new_password_2[0] }}</li>
                            </ul>
                          </div>
                          <button
                              class="btn btn-info"
                              type="button"
                              @click="save_account">{{ $t('profile.save-password') }}
                          </button>
                        </form>
                        <hr>
                        <p>{{ $t('profile.delete-info') }}</p>
                        <button class="btn btn-secondary" type="button">
                          <span
                              class="text-danger"
                              @click="delete_account">{{ $t('profile.delete-account') }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import { objectToFormData, parseApiError } from '@/utils'
import message from '@/message'
import axios from 'axios'

const getData = (route, next) => {
  Promise.all([
    api.get(`/profile/`)
  ])
      .then(([profile]) => {
        next({
          user: profile.data.results[0],
          supplier: profile.data.results[0].supplier,
          picture: profile.data.results[0].picture,
          picture_data: profile.data.results[0].picture_data,
          photo: profile.data.results[0].picture && process.env.FSS_URL.concat('get/', profile.data.results[0].picture)
        })
      })
}

export default {
  data () {
    return {
      user: {},
      errors: {},
      picture: null,
      picture_data: {},
      photo: null,
      supplier: null,
      current_password: null,
      new_password: null,
      new_password_2: null,
      attrs: {
        accept: 'image/*'
      }
    }
  },
  methods: {
    save_user () {
      this.errors = {}
      const data = objectToFormData({
        ...this.user,
        supplier: this.supplier ? this.supplier.id : null,
        picture: this.picture,
        role: this.user.role.toUpperCase()
      })
      api.patch(`/users/${this.user.id}/`, data)
          .then(resp => {
            this.user = resp.data
            if (this.picture) {
              this.user.picture = this.picture
              this.$store.commit('update', this.user)
              this.photo = process.env.FSS_URL.concat('get/', this.picture)
            } else {
              this.photo = null
            }
            message.success(this.$i18n.t('profile.account-updated'))
            this.$router.go(0)
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
    },
    delete_account () {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('profile.are-you-sure'),
        text: this.$i18n.t('profile.are-you-sure-text-cancel'),
        showCancelButton: true
      })
          .then((choice) => {
            if (choice.value) {
              api.get('/delete_account/')
                  .then(() => {
                    message.success(this.$i18n.t('profile.account-deleted'))
                    setTimeout(() => {
                      this.$store.commit('log_out')
                      this.$router.push({ path: '/' })
                    }, 2000)
                  })
                  .catch(() => {
                    message.error(this.$i18n.t('profile.something-went-wrong'))
                  })
            }
          })
    },
    save_account () {
      this.errors = {}
      if (!this.new_password || !this.new_password_2 || !this.current_password) {
        if (!this.new_password) {
          this.errors.new_password = [this.$i18n.t('profile.password-empty')]
        }
        if (!this.new_password_2) {
          this.errors.new_password_2 = [this.$i18n.t('profile.password-empty')]
        }
        if (!this.current_password) {
          this.errors.current_password = [this.$i18n.t('profile.password-empty')]
        }
      } else if (this.new_password !== this.new_password_2) {
        this.errors.new_password = [this.$i18n.t('profile.passwords-not-the-same')]
        this.errors.new_password_2 = [this.$i18n.t('profile.passwords-not-the-same')]
      } else {
        api.post(`/check_password/`, {
          new_password: this.new_password,
          current_password: this.current_password
        })
            .then(() => {
              api.post(`/change_profile_password/`, {
                'password1': this.new_password,
                'password2': this.new_password_2
              })
                  .then(() => {
                    message.success(this.$i18n.t('profile.password-saved'))
                  })
                  .catch(error => {
                    if (error.response && error.response.status === 400) {
                      this.errors = parseApiError(error, this.$i18n)
                    }
                  })
            })
            .catch(error => {
              if (error.response && error.response.status === 400) {
                this.errors = parseApiError(error, this.$i18n)
              }
            })
      }
    }
  },
  computed: {
    is_personal_code_disabled () {
      return this.user.is_authorized
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue